import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import OutlineDelete from 'react-md-icon/dist/OutlineDelete';
import { deleteEmployeeDocument, DELETE_EMPLOYEE_DOCUMENT, deleteCompanyDocument, DELETE_COMPANY_DOCUMENT } from '../../modules/docs/docs';
import './DeleteButton.scss';
import { Spinner } from '../../components';
import { LOADING_PROP_TYPE } from '../../modules';

class DeleteButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      disabledTooltipOpen: false,
      tooltipOpen: false,
    };
    this.toggle = this.toggle.bind(this);
    this.toggleDisabledTooltip = this.toggleDisabledTooltip.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { loading } = this.props;
    if ((loading[DELETE_EMPLOYEE_DOCUMENT] !== 'loading' && prevProps.loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading') ||
    (loading[DELETE_COMPANY_DOCUMENT] !== 'loading' && prevProps.loading[DELETE_COMPANY_DOCUMENT] === 'loading')) {
      this.close();
    }
  }
  toggleDisabledTooltip() {
    this.setState({
      disabledTooltipOpen: !this.state.disabledTooltipOpen,
    });
  }
  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }
  handleClickOutside() {
    const { loading } = this.props;
    if (loading[DELETE_EMPLOYEE_DOCUMENT] !== 'loading' || loading[DELETE_COMPANY_DOCUMENT] !== 'loading') {
      this.close();
    }
  }
  close() {
    this.setState({
      tooltipOpen: false,
    });
  }

  deleteSubmitButton() {
    const {
      id,
      loading,
      additionalInfo,
    } = this.props;
    let buttonText = 'DELETE';
    let buttonIcon;
    if (loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading' || loading[DELETE_COMPANY_DOCUMENT] === 'loading') {
      buttonText = 'DELETING';
      buttonIcon = <Spinner className="mr-2 float-left white" width="0.75rem" />;
    }
    return (
      <Button
        color="danger"
        onClick={(e) => {
          e.stopPropagation();
          if (additionalInfo.employeeId) {
          this.props.deleteEmployeeDocument(additionalInfo.companyId, additionalInfo.employeeId, id);
          } else {
            this.props.deleteCompanyDocument(additionalInfo.companyId, id);
          }
        }}
        size="sm"
        className="d-flex align-items-center"
        disabled={loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading' || loading[DELETE_COMPANY_DOCUMENT] === 'loading'}
      >
        {buttonIcon}
        <FormattedMessage id={buttonText} />
      </Button>
    );
  }

  render() {
    const {
      uniqueId,
      id,
      loading,
      deleteQuestion,
      message,
      disabled,
    } = this.props;
    if (!id) return null;
    return (
      <Fragment>
        <Button
          color="link"
          className={`btn-delete ${disabled.isDisabled ? 'btn-delete-disabled' : ''}`}
          id={`${uniqueId}-${id}`}
          onClick={(e) => {
            e.stopPropagation();
            this.toggle();
          }}
          loading={loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading' || loading[DELETE_COMPANY_DOCUMENT] === 'loading'}
          disabled={loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading' || loading[DELETE_COMPANY_DOCUMENT] === 'loading'}
        >
          <OutlineDelete
            style={{ fontSize: '1.5rem' }}
          />
        </Button>
        {
          disabled && disabled.isDisabled && disabled.toolTipMessage ? (
            <Tooltip
              placement="bottom"
              isOpen={this.state.disabledTooltipOpen}
              target={`${uniqueId}-${id}`}
              container="#asure-react-app"
              toggle={this.toggleDisabledTooltip}
            >
              <FormattedMessage id={disabled.toolTipMessage} />
            </Tooltip>
          ) : (
            <Tooltip
              placement="bottom"
              isOpen={this.state.tooltipOpen}
              target={`${uniqueId}-${id}`}
              container="#asure-react-app"
              innerClassName="bg-white text-muted px-3 py-2"
              className="delete-tooltip pr-4"
              onClick={(e) => {
                e.stopPropagation();
              }}
              // The following props prevent the tooltip's visibility flashing in the UI when the parent component re-renders
              delay={{
                show: 0,
                hide: 0,
              }}
              fade={false}
            >
              <div className="row text-left">
                <div className="col-12">
                  <h6 className="font-weight-bold text-dark mb-1 mt-2"><FormattedMessage id={deleteQuestion} /></h6>
                  <small className="text-muted"><FormattedMessage id="THIS_ACTION_CANNOT_BE_UNDONE" /></small>
                  {
                    message && (
                      <p className="my-2 alert alert-warning p-2"><FormattedMessage id={message} /></p>
                    )
                  }
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <Button
                    color="default"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.close();
                    }}
                    className="mr-2"
                    size="sm"
                    disabled={loading[DELETE_EMPLOYEE_DOCUMENT] === 'loading' || loading[DELETE_COMPANY_DOCUMENT] === 'loading'}
                  >
                    <FormattedMessage id="CANCEL" />
                  </Button>
                  {this.deleteSubmitButton()}
                </div>
              </div>
            </Tooltip>
          )
        }
      </Fragment>
    );
  }
}

DeleteButton.defaultProps = {
  id: null,
  message: undefined,
  disabled: {},
  additionalInfo: {},
};

DeleteButton.propTypes = {
  uniqueId: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  additionalInfo: PropTypes.objectOf(PropTypes.any),
  loading: LOADING_PROP_TYPE.isRequired,
  deleteEmployeeDocument: PropTypes.func.isRequired,
  deleteCompanyDocument: PropTypes.func.isRequired,
  deleteQuestion: PropTypes.string.isRequired,
  message: PropTypes.string,
  disabled: PropTypes.shape({
    isDisabled: PropTypes.bool,
    toolTipMessage: PropTypes.string,
  }),
};

export default connect(
  (state) => {
    const { appState: { loading } } = state;
    return {
      loading,
    };
  },
  dispatch => ({
    deleteEmployeeDocument: (companyId, employeeId, documentId) =>
      dispatch(deleteEmployeeDocument(companyId, employeeId, documentId)),
    deleteCompanyDocument: (companyId, documentId) =>
      dispatch(deleteCompanyDocument(companyId, documentId)),
  })
)(onClickOutside(DeleteButton));



// WEBPACK FOOTER //
// ./src/components/DeleteButton/DeleteButton.jsx